export const colHeaders = [
    'Branch Id',
    'BranchType Id',
    'Branch Type',    
    'Branch Name',
    'Country Id',
    'Country',
    'Location Time Zone Id',
    'Location Time Zone',
    'Delete Location',
];